var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Regular icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2ZM7 6C7 4.34315 8.34315 3 10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6ZM5.00873 11C3.90315 11 3 11.8869 3 13C3 14.6912 3.83281 15.9663 5.13499 16.7966C6.21303 17.484 7.60667 17.8663 9.12572 17.9705L9.42539 16.9864C7.9297 16.9145 6.62328 16.5596 5.67262 15.9534C4.62226 15.2837 4 14.3088 4 13C4 12.4467 4.44786 12 5.00873 12L9.59955 12C9.78244 11.6422 10.0034 11.3071 10.257 11L5.00873 11ZM19 14.5C19 16.9853 16.9853 19 14.5 19C13.7085 19 12.9647 18.7956 12.3185 18.4368L10.5294 18.9812C10.2162 19.0765 9.92358 18.7838 10.0189 18.4707L10.5635 16.6821C10.2045 16.0358 10 15.2918 10 14.5C10 12.0147 12.0147 10 14.5 10C16.9853 10 19 12.0147 19 14.5ZM12.5 13C12.2239 13 12 13.2239 12 13.5C12 13.7761 12.2239 14 12.5 14H16.5C16.7761 14 17 13.7761 17 13.5C17 13.2239 16.7761 13 16.5 13H12.5ZM12 15.5C12 15.7761 12.2239 16 12.5 16H14.5C14.7761 16 15 15.7761 15 15.5C15 15.2239 14.7761 15 14.5 15H12.5C12.2239 15 12 15.2239 12 15.5Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanChat);
export default __webpack_public_path__ + "static/media/human-chat.2426198096859715f29d7c5a4a69ea9d.svg";
export { ForwardRef as ReactComponent };